<template>
  <div class="forms">
    <v-container fluid>
      <h1>FAQs</h1>
      <div class="card-curvey pa-0 delete-wrapper mt-3 pb-2" v-for="(faq,index) in faqs">
        <faq-item :item="faq"></faq-item>
        <v-btn
          @click="deleteFaq(index)"
          fab small color=""
          class="delete-button"
        ><v-icon small color="#666">delete_outline</v-icon></v-btn>
      </div>
      <v-btn
        large round flat block
        class="primary--text"
        @click="addFaq"
      >
        <v-icon>add_circle_outline</v-icon>
        Add New Question
      </v-btn>
    </v-container>
  </div>
</template>

<script>
  import common from "../../../../utils/common";
  import faqData from "./faqData";
  import faqItem from "./faqItem";
  export default {
    name: "faqs",
    components: {
      faqData,
      faqItem
    },
    data() {
      return {
        faqs: [],
      }
    },
    mounted() {
      this.getFaqs()
    },
    methods: {
      getFaqs () {
        this.$store.dispatch('setLoader',true)
        this.$http_bot.get('bot_objects/faqs')
          .then(response=> {
            this.faqs = response.data
            this.$store.dispatch('setLoader',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      addFaq () {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.post('/bot_objects/faqs',{
          bot_id: this.$store.state.bot.botId,
          active: true,
          body:
            {
              question: '',
              answer: '',
              locale: ''
            }
        })
          .then(response=> {
            this.faqs.push(response.data)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      deleteFaq(index) {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.delete(`/bot_objects/faqs/${this.faqs[index].id}`)
          .then(response=>{
            this.faqs.splice(index,1)
            this.$store.dispatch('setSavingStatus',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', false)
            }
          })
      },
    }
  }
</script>

<style scoped>

</style>
